import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import OtherHousesOutlinedIcon from '@mui/icons-material/OtherHousesOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import CategoryIcon from '@mui/icons-material/Category';
import { EmployeeCreate } from '../../components/employee/EmployeeCreate';
import { EmployeeEdit } from '../../components/employee/EmployeeEdit';
import { EmployeeList } from '../../components/employee/EmployeeList';
import { MerchantEdit } from '../../components/merchant/Merchant';
import { SubMerchantCreate } from '../../components/sub-merchant/SubMerchantCreate';
import { SubMerchantEdit } from '../../components/sub-merchant/SubMerchantEdit';
import { SubMerchantList } from '../../components/sub-merchant/SubMerchantList';
import {
  TerminalCreate,
  TerminalEdit,
  TerminalList,
} from '../../components/terminal/Terminal';
import { EmployeeRoleKeys } from '../../constants/Role';
import { TransactionList } from '../../components/transaction/TransactionList';
import { CategoryList } from '../../components/category/CategoryList';
import { CategoryCreate } from '../../components/category/CategoryCreate';
import { CategoryEdit } from '../../components/category/CategoryEdit';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { BillList } from '../../components/bill/Bill';

export const resources = [
  {
    name: 'Merchant',
    icon: AccountBalanceOutlinedIcon,
    list: undefined,
    create: undefined,
    edit: MerchantEdit,
    showWithRoles: [EmployeeRoleKeys.MASTER_MANAGER],
    isPublic: false,
  },
  {
    name: 'SubMerchant',
    icon: OtherHousesOutlinedIcon,
    list: SubMerchantList,
    create: SubMerchantCreate,
    edit: SubMerchantEdit,
    showWithRoles: [EmployeeRoleKeys.MASTER_MANAGER, EmployeeRoleKeys.MANAGER],
    isPublic: false,
  },
  {
    name: 'Employee',
    icon: PeopleOutlineOutlinedIcon,
    list: EmployeeList,
    create: EmployeeCreate,
    edit: EmployeeEdit,
    showWithRoles: [EmployeeRoleKeys.MASTER_MANAGER, EmployeeRoleKeys.MANAGER],
    isPublic: false,
  },
  {
    name: 'Terminal',
    icon: PointOfSaleOutlinedIcon,
    list: TerminalList,
    create: TerminalCreate,
    edit: TerminalEdit,
    showWithRoles: [
      EmployeeRoleKeys.MASTER_MANAGER,
      EmployeeRoleKeys.MANAGER,
      EmployeeRoleKeys.CASHIER,
    ],
    isPublic: false,
  },
  {
    name: 'Transaction',
    icon: CurrencyExchangeOutlinedIcon,
    list: TransactionList,
    create: undefined,
    edit: undefined,
    showWithRoles: [
      EmployeeRoleKeys.MASTER_MANAGER,
      EmployeeRoleKeys.MANAGER,
      EmployeeRoleKeys.CASHIER,
    ],
    isPublic: true,
  },
  {
    name: 'Category',
    icon: CategoryIcon,
    list: CategoryList,
    create: CategoryCreate,
    edit: CategoryEdit,
    showWithRoles: [EmployeeRoleKeys.MASTER_MANAGER, EmployeeRoleKeys.MANAGER],
    isPublic: false,
  },
  {
    name: 'Bill',
    icon: LocalAtmIcon,
    list: BillList,
    create: undefined,
    edit: undefined,
    showWithRoles: [
      EmployeeRoleKeys.MASTER_MANAGER,
      EmployeeRoleKeys.MANAGER,
      EmployeeRoleKeys.CASHIER,
    ],
    isPublic: false,
  },
];
